// Public constants that are safe to include in client side code

export const SPU_COOKIE = 'SPUStoreName';
export const STS_COOKIE = 'SPUSTSStatus';
export const SPU_MESSAGE = 'SPUMessage';
export const SPU_CHANGED_MARKER = '~Changed~';
